import { GroupTypeEnum } from "../../../Pages/GroupDetailsPage/Group.types";

const PRECISION = 1;

export const POI_PREFIX = "poi_";
export const GOOGLE_PLACE_PREFIX = "gp_";

export const calculateDistanceText = (
    distanceInKilometers: number,
    groupType: GroupTypeEnum,
): string => {
    let postfix;
    switch (groupType) {
        case GroupTypeEnum.HOTEL:
        case GroupTypeEnum.HOLIDAY_HOME:
            postfix = "km entfernt";
            break;
        case GroupTypeEnum.CITY:
            postfix = "km zum Zentrum";
            break;
        default:
            return "";
    }
    const distance = Number(distanceInKilometers.toFixed(PRECISION));
    if (distance === 0) {
        return "vor Ort";
    }
    return `${distance.toLocaleString("de-DE")} ${postfix}`;
};

export const combineSubtitle = (subtitles: string[]) => {
    return subtitles.filter((item) => item).join(" ᛫ ");
};
